<template>
  <page-content-placeholder
    icon="help"
    prompt-text="No references found"
  >
    <template #message>
      Sorry, we couldn't find any references that match your criteria.
    </template>

    <template #action>
      <action-button color="primary" @click="$emit('clear')">
        <v-icon left>clear_all</v-icon>
        Clear All Filters
      </action-button>
    </template>
  </page-content-placeholder>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';

export default {
  name: 'ScreenTabFilteringEmptyState',
  components: {
    ActionButton,
    PageContentPlaceholder,
  },
  emits: ['clear'],
};
</script>
